module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ2_3.ba9f283e.svg";